import "../../assets/css/product.scss";

function ProductPaymentResultPage() {
  return <div>test</div>;
}

export default ProductPaymentResultPage;
